import React, { Component } from 'react'
import i18n from 'live/services/i18n'
import ActionToggle from 'live/components/ui/action-toggle'
import ButtonSvg from '../../../assets/timeline.svg'
import LiveModal from 'live/components/ui/Modal'

type TimelineConfig = {
    disabled?: boolean
    mode?: string
    applyDashboardFiltersToTimeline?: boolean
}
type Props = {
    dashboardId?: number
    saveTimelineConfig?: (dashboardId: number, config: TimelineConfig) => void
    timelineConfig?: TimelineConfig
}

export default class TimelineEditionModalConfigComponent extends Component<Props> {
    constructor (props) {
        super(props)

        this.state = {
            ...props,
            ...props.timelineConfig,
            showTimelineModal: false
        }

        this.toggleDisabled = this.toggleDisabled.bind(this)
        this.selectMode = this.selectMode.bind(this)
        this.submit = this.submit.bind(this)
        this.toggleTimelineModal = this.toggleTimelineModal.bind(this)
    }

    componentDidMount () {
        this.mounted = true
    }

    componentWillUnmount () {
        this.mounted = false
    }

    UNSAFE_componentWillReceiveProps (nextProps) {
        if (this.mounted) this.setState({ ...nextProps.timelineConfig })
    }

    submit () {
        const { disabled, mode, applyDashboardFiltersToTimeline } = this.state

        this.props.saveTimelineConfig(this.props.dashboardId, {
            disabled: disabled,
            mode: mode,
            applyDashboardFiltersToTimeline: applyDashboardFiltersToTimeline
        })

        this.toggleTimelineModal()
    }

    toggleDisabled () {
        this.setState({ disabled: !this.state.disabled })
    }

    selectMode (e) {
        if (this.state.disabled) return

        this.setState({
            mode: e.target.value
        })
    }

    toggleTimelineModal (obj) {
        this.setState({
            showTimelineModal: !this.state.showTimelineModal,
            ...obj
        })
    }

    toggleApplyDashboardFiltersToTimeline = () => {
        this.setState({
            applyDashboardFiltersToTimeline: !this.state.applyDashboardFiltersToTimeline
        })
    }

    render () {
        const { isVisible } = this.props
        const { disabled, mode, applyDashboardFiltersToTimeline } = this.state

        return (
            <li>
                {isVisible && (
                    <div
                        className="item-container item-container--align-center"
                        onClick={() => this.toggleTimelineModal({})}
                    >
                        <i style={{ lineHeight: '0px', transform: 'scale(0.8) translate(3px, 0px)' }}>
                            <ButtonSvg />
                        </i>
                        <span>{i18n('Timeline options')}</span>
                    </div>
                )}

                <LiveModal
                    show={this.state.showTimelineModal}
                    onHide={() => this.toggleTimelineModal({})}
                    animation={false}
                    className="timeline-config-modal modal-xs with-padding"
                >
                    <LiveModal.Header>
                        <LiveModal.Title>{i18n('Timeline options')}</LiveModal.Title>
                    </LiveModal.Header>
                    <LiveModal.Body>
                        <div className="flex flex-center-items">
                            <ActionToggle className="centered" active={!disabled} onChange={this.toggleDisabled} />
                            <span>{i18n('Enable timeline')}</span>
                        </div>

                        <br />

                        <div className="flex flex-center-items">
                            <ActionToggle
                                className="centered"
                                active={applyDashboardFiltersToTimeline}
                                onChange={this.toggleApplyDashboardFiltersToTimeline}
                            />
                            <span>{i18n('Filter timeline annotations')}</span>
                        </div>
                        <div className="timeline-config-modal__radios" style={{ opacity: !disabled ? '1' : '0.5' }}>
                            <label>{i18n('Timeline format')}</label>

                            <label className="radio inline">
                                <input
                                    type="radio"
                                    value="temporal"
                                    checked={mode == 'temporal'}
                                    onChange={this.selectMode}
                                />
                                {i18n('Temporal')}
                            </label>
                            <label className="radio inline">
                                <input
                                    type="radio"
                                    value="numeric"
                                    checked={mode == 'numeric'}
                                    onChange={this.selectMode}
                                />
                                {i18n('Numeric')}
                            </label>
                        </div>
                    </LiveModal.Body>
                    <LiveModal.Footer>
                        <LiveModal.ModalActions
                            onSubmit={this.submit}
                            submitText={i18n('save')}
                            submitBtnClassName="btn btn-primary"
                            onCancel={() => this.toggleTimelineModal({ ...this.props.timelineConfig })}
                            cancelText={i18n('cancel')}
                        />
                    </LiveModal.Footer>
                </LiveModal>
            </li>
        )
    }

}
